export const DeleteSvg = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.59961 21C7.04961 21 6.57894 20.8043 6.18761 20.413C5.79628 20.0217 5.60028 19.5507 5.59961 19V6H4.59961V4H9.59961V3H15.5996V4H20.5996V6H19.5996V19C19.5996 19.55 19.4039 20.021 19.0126 20.413C18.6213 20.805 18.1503 21.0007 17.5996 21H7.59961ZM9.59961 17H11.5996V8H9.59961V17ZM13.5996 17H15.5996V8H13.5996V17Z"
      fill="#D30000"
    />
  </svg>
);
